import { render, staticRenderFns } from "./CustomerOrderedDetails.vue?vue&type=template&id=23c64d22&scoped=true"
import script from "./CustomerOrderedDetails.vue?vue&type=script&lang=js"
export * from "./CustomerOrderedDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerOrderedDetails.vue?vue&type=style&index=0&id=23c64d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c64d22",
  null
  
)

export default component.exports